import API from '../AxiosInstance';

export default {
  getClients: function(payload) {
    return API.get(`nodes/${payload.nodeId}/apiclients`)
      .then((response) => {
        return response?.data || [];
      });
  },

  getClientsByUser: function(payload) {
    return API.get(`nodes/${payload.nodeId}/users/${payload.userId}/apiclients`)
      .then((response) => {
        return response?.data || [];
      });
  },

  createClient: function(payload) {
    const body = {
      name: payload.name,
      userid: payload.userId,
      scopes: payload.scopes,
    };

    return API.post(`nodes/${payload.nodeId}/apiclients`, body)
      .then((response) => {
        return response?.data || [];
      });
  },

  deleteClient: function(payload) {
    return API.delete(`nodes/${payload.nodeId}/apiclients/${payload.clientId}`)
      .then((response) => {
        return response?.data || [];
      });
  },

  updateClientStatus: function(payload) {
    const body = {
      active: payload.active,
    };

    return API.patch(`nodes/${payload.nodeId}/apiclients/${payload.clientId}`, body);
  },

  getClient: function(payload) {
    return API.get(`nodes/${payload.nodeId}/apiclients/${payload.clientId}`)
      .then((response) => {
        return response?.data || {};
      });
  },

  updateClient: function(payload) {
    const body = {};
    if (payload.name !== undefined) {
      body.name = payload.name;
    }
    if (payload.scopes !== undefined) {
      body.scopes = payload.scopes;
    }

    return API.put(`nodes/${payload.nodeId}/apiclients/${payload.clientId}`, body)
      .then((response) => {
        return response?.data || {};
      });
  },
}
